<template>
  <nav class="nav primary" :class="open ? 'is-open' : ''">
	  <div>
		  <div class="grid-container c2">
			  <template v-for="(slice, index) in slices">
		      <template v-if="slice.slice_type === 'nav_item'">
			      <div :key="'slice-' + index" class="nav-group">
			      	<prismic-link :field="slice.primary.nav_item_link" class="nav-group-title">
					    	<span @click="closeNav">{{ slice.primary.nav_item_label }}</span>
			      	</prismic-link>
			        <ul>
				        <li v-for="(item, index) in slice.items" :key="'sub-item-' + index" class="text-condensed text-uppercase text-bold"  @click="closeNav">
					        <template v-if="item.sub_nav_item_link.link_type === 'Document'">
					        	<template v-if="item.sub_nav_item_section === null">
					        		<prismic-link :field="item.sub_nav_item_link">
					        			<span>{{ item.sub_nav_item_label }}</span>
					        		</prismic-link>
						    	</template>
						    	<template v-else>
						    		<router-link :to="'/' + item.sub_nav_item_link.uid + '/' + item.sub_nav_item_section">
						    			<span>{{ item.sub_nav_item_label }}</span>
						    		</router-link>
						    	</template>
					        </template>
							<template v-else>
								<prismic-link :field="item.sub_nav_item_link">
									<span>{{ item.sub_nav_item_label }}</span>
						      	</prismic-link>
							</template>
					    </li>
			        </ul>
			      </div>
		      </template>
		      <template v-else-if="slice.slice_type === 'nav_link'">
			      <div class="nav-group">
			      	<prismic-link :field="slice.primary.nav_item_link" class="nav-group-title">
					    	<span @click="closeNav">{{ slice.primary.nav_item_label }}</span>
			      	</prismic-link>
			      </div>
		      </template>
		    </template>
		  </div>
	  </div>
  </nav>
</template>


<script>

const removeClass = function (target, className) {
  target.classList.remove(className);
}

export default {
  name: 'Navigation',
  data () {
	  return {
		  slices: []
	  };
  },
  methods: {
	  itemDetails(item) {
		  console.log(item)
	  },
	  getContent () {
		  this.$prismic.client.getSingle('navigation')
		  	.then((document) => {
					console.log(document.data.nav);
			  	this.slices = document.data.nav;
		  	})
	  },
	  sanitizeTitle (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd');
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '');
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-');
      
      return slug;
    },
	  closeNav () {
    	this.$store.dispatch('toggleNav');
    }
  },
  created () {
	  this.getContent();
  },
  mounted () {
	  
  },
  computed: {
	  open () {
		  return this.$store.state.navOpen
	  }
  },
  watch: {
	  open: function (open) {
		  console.log('open watcher')
	  }
  }
}
</script>

<style scoped>
	
</style>
